export default "__VITE_ASSET__BFol3kbY__"